'use strict';
// @file
// Main entry point for custom components

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router';
import QuizController from './pages/quizController/quizController';
import TopicTile from './components/topicTile/topicTile';
import styles from './home.module.css';

// Instantiate our React app
document.addEventListener('DOMContentLoaded', () => {
  // React for quiz tool
  if (document.getElementById('app') != null) {
    const root = createRoot(document.getElementById('app'));
    // TODO - fix this better
    root.render(
      <BrowserRouter>
        <Routes>
          <Route path='/acprr-tool' element={<QuizController />} />
        </Routes>
      </BrowserRouter>
    );
  }
  const printDateTimeSpan = document.getElementById('print-date-time');
  if (printDateTimeSpan) {
    const now = new Date();
    // Get date components with leading zeros for day and month
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = now.getFullYear();
    const exportDate = `${day}/${month}/${year}`;
    printDateTimeSpan.textContent = exportDate;
  }
  // React for homepage UI Tiles
  if (document.getElementById('home') != null) {
    const root = createRoot(document.getElementById('home'));
    // TODO - fix this better
    root.render(
      <>
        <div className={styles.subHeaderContainer}>
          <h2 className={styles.viewingRequirementsHeader}>
            Explore requirements by topic
          </h2>
          <p className={styles.viewingRequirementsParagraph}>
            Viewing requirements by topic may limit your results, as not all
            requirements are aligned with a specific topic.
          </p>
        </div>
        <div className={styles.topicsContainer}>
          <TopicTile
            icon='agreement'
            label='Agreements, plans and information'
            href='/acprr-tool/?step=5&r=agreements'
          />
          <TopicTile
            icon='governance'
            label='Governance'
            href='/acprr-tool/?step=5&r=governance'
          />
          <TopicTile
            icon='reporting'
            label='Reporting and notifications'
            href='/acprr-tool/?step=5&r=reporting'
          />
          <TopicTile
            icon='workforce'
            label='Workforce'
            href='/acprr-tool/?step=5&r=workforce'
          />
          <TopicTile
            icon='complaints'
            label='Complaints and feedback'
            href='/acprr-tool/?step=5&r=complaints'
          />
        </div>
      </>
    );
  }
});
